import { render } from "./TheHeader.vue?vue&type=template&id=7c49593a&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=7c49593a&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c49593a"]])

export default __exports__